/**
 * Base URL da API e versão. Módulo isolado para evitar dependência circular com main.js
 * (main → utils → Form → main causava "Cannot access getApiBaseUrl before initialization").
 */
import { resolveApiBase } from './shared/utils/resolveApiBase';

function getApiVersion() {
  try {
    if (typeof window !== 'undefined' && window.__store && window.__store.getters && window.__store.getters.api_version) {
      return window.__store.getters.api_version;
    }
  } catch (e) {
    // ignore
  }
  return 1;
}

/** Versão da API (1 ou 2), usado por main.js e outros. */
export function apiVersion() {
  return getApiVersion();
}

/**
 * Base URL da API (intranet ou Netskope, ver resolveApiBase). Em dev (dsv) usa o mesmo host da página (localhost ou IP),
 * assim funciona ao acessar por http://192.168.15.5:8081 com Docker em outra máquina.
 */
export function getApiBaseUrl() {
  if (process.env.VUE_APP_ENV === 'dsv') {
    if (typeof globalThis !== 'undefined' && globalThis.window !== undefined) {
      const port = process.env.VUE_APP_DEV_API_PORT || '8000';
      return 'http://' + globalThis.window.location.hostname + ':' + port;
    }
    return process.env.VUE_APP_ENDPOINT || 'http://localhost:8000';
  }
  return resolveApiBase(getApiVersion());
}
